export default __webpack_public_path__ + "static/media/firebase.8b5f3455.webp";